/**
 * ImageKit URL helpers for Student Signal.
 *
 * Base URL is read from REACT_APP_IMAGEKIT_URL.
 * Brand rule: when ImageKit (or the slug) is unavailable, fall back to the
 * local branded SVG illustration — never to an external/stock image URL.
 */

const BASE = process.env.REACT_APP_IMAGEKIT_URL;

export const LOCAL_CAMPUS_FALLBACK = '/assets/fallback-campus-hero.svg';

const joinPath = (path) => {
  if (!BASE) return null;
  // Guarantee exactly one slash between base and path
  const base = BASE.endsWith('/') ? BASE : `${BASE}/`;
  const tail = path.startsWith('/') ? path.slice(1) : path;
  return `${base}${tail}`;
};

/**
 * College hero/banner image.
 * Returns ImageKit URL when slug is provided; otherwise the local branded fallback.
 */
export const getCollegeHero = (slug) => {
  if (!slug) return LOCAL_CAMPUS_FALLBACK;
  return joinPath(`colleges/heroes/${slug}.jpg`) || LOCAL_CAMPUS_FALLBACK;
};

/**
 * College logo image.
 * Returns ImageKit URL when slug is provided; otherwise null so the caller
 * can render an initials-based fallback.
 */
export const getCollegeLogo = (slug) => {
  if (!slug) return null;
  return joinPath(`colleges/logos/${slug}.png`);
};

/**
 * Scholarship card image.
 * Returns ImageKit URL when id is provided; otherwise null.
 */
export const getScholarshipImage = (id) => {
  if (!id) return null;
  return joinPath(`scholarships/${id}.jpg`);
};

/**
 * onError handler that swaps a failed remote image for the local branded SVG.
 * Use on any <img> whose src is an ImageKit URL.
 */
export const handleCampusImgError = (event) => {
  if (event?.currentTarget && event.currentTarget.src !== LOCAL_CAMPUS_FALLBACK) {
    event.currentTarget.src = LOCAL_CAMPUS_FALLBACK;
  }
};
